<mat-list>

  <div class="holder">
    <mat-list-item>
      <h1>{{threadCount | number}} Chats</h1>
      <button mat-icon-button (click)="toggleColors()" class="color-button">
        <mat-icon>palette</mat-icon>
      </button>
    </mat-list-item>

    <!-- Sort Select -->
    <mat-list-item class="thread-sort-list-item">
      <mat-form-field appearance="fill">
        <mat-label>Sort By</mat-label>
        <mat-icon matPrefix>sort</mat-icon>
        <mat-select
          [value]="selectedSort"
          (valueChange)="sortChange($event)"
          [compareWith]="compareSorts"
          disableOptionCentering="true">
          <mat-option *ngFor="let sort of sortTypes" [value]="sort">
            {{ sort.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-checkbox
        class="all-threads-checkbox"
        [checked]="allThreadsSelected"
        [indeterminate]="someThreadsSelected()"
        (change)="setAllThreadSelection($event.checked)"
        [color]="'primary'">
      </mat-checkbox>
    </mat-list-item>
  </div>

  <!-- <mat-list-item class="list-head-spacer"></mat-list-item>-->

  <!-- Chat List -->
  <mat-selection-list #threads (selectionChange)="onSelectionChange($event)">
    <mat-list-option *ngFor="let thread of threads$ | async; trackBy: trackByThreadId"
      [appOptionColor]="getColors(thread)"
      [refreshColor]="refreshList$ | async"
      [colorId]="thread.id"
      [color]="'primary'"
      [selected]="true"
      id="{{thread.id}}"
      [attr.title]="participantsList(thread)">
      <mat-icon
        matListAvatar
        [matBadge]="thread.nb_participants > 3 ? thread.nb_participants : null"
        matBadgePosition="below">
        {{getIcon(thread)}}
      </mat-icon>
      <div matLine class="thread-list-line">
        <h3>{{thread.title}}</h3>
        <mat-chip-list [selectable]="false">
          <mat-chip [selectable]="false">{{ thread.nb_messages | number }}</mat-chip>
        </mat-chip-list>
      </div>
      <p matLine>
        <span><i>{{ getSubtitle(thread) }}</i></span>
      </p>
  <!--    <p matLine><span>{{thread.nb_messsages}} Messages</span></p>-->
    </mat-list-option>
  </mat-selection-list>

</mat-list>
